import FilterGroup from './filter-group.model';

class FilterGroupAnd extends FilterGroup {
  constructor(id: string) {
    super(id);
    this.logic = 'AND';
  }

  filter(entity: any): boolean {
    for (const filter of this.filters) {
      if (!filter.filter(entity)) {
        return false;
      }
    }
    return true;
  }

  toString(): string {
    throw new Error('Method not implemented.');
  }
}
export default FilterGroupAnd;
